export const REVIEW_BENEFITS = Object.freeze({
  sleep: 'Get better sleep',
  stress: 'Unwind from stress',
  focus: 'Focus & be productive',
  uplift: 'Feel energized & uplifted',
  relief: 'Relieve physical pain & discomfort',
  social: 'Socialize & have a good time',
  relax: 'Chill & relax',
})

export const REVIEW_QUALITIES = Object.freeze({
  taste: 'Taste/favor',
  texture: 'Texture',
  smell: 'Smell/aroma',
  appearance: 'Appearance',
  effects: 'Effects',
})

export const REVIEW_EXPERIENCES = Object.freeze({
  new: 'New (Few time per year or less)',
  occasional: 'Occasional (Few times per month)',
  frequent: 'Frequent (Few times per week)',
  often: 'Often (Everyday)',
})
